import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function SignInScreen({ onSignIn }: { onSignIn: () => Promise<void> }) {
  const { t } = useTranslation()
  const [failed, setFailed] = useState(false)

  async function handleClick() {
    setFailed(false)
    try {
      await onSignIn()
    } catch {
      // The popup being dismissed and a genuine auth failure are
      // indistinguishable to the user here, and neither is actionable beyond
      // trying again — so both get the same message.
      setFailed(true)
    }
  }

  return (
    <main className="asf-centered">
      <h1>{t('sign_in_title')}</h1>
      <button type="button" onClick={handleClick}>
        {t('sign_in_button')}
      </button>
      {failed && <p role="alert">{t('sign_in_failed')}</p>}
    </main>
  )
}
